<!-- RecipeRating component -->
<template>
  <div
    v-if="!isLoading && ratingValue !== null"
    class="recipe-rating d-flex align-items-center"
  >
    <span v-for="star in 5" :key="star" class="star">
      <i :class="starClass(star)"></i>
    </span>
    <span
      v-if="likesCount !== null && likesCount > 0"
      class="likes-count ms-2 text-muted"
      style="font-size: 0.9em"
      >({{ likesCount }})</span
    >
  </div>
  <div v-else-if="isLoading" class="recipe-rating">
    <small class="text-muted">Загрузка рейтинга...</small>
  </div>
  <div v-else-if="error && !isLoading" class="recipe-rating">
    <!-- Optionally show a small error indicator or nothing -->
    <!-- <small class="text-danger" title="Ошибка загрузки рейтинга"><i class="bi bi-exclamation-circle"></i></small> -->
  </div>
  <!-- If no ratingValue and not loading and no error, it means no rating data or 0 rating, stars will be grey -->
</template>

<script>
const CMD_RECIPE_RATING_GET = "recipe.rating.get";

export default {
  name: "RecipeRating",
  props: {
    recipeId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      ratingValue: null, // Numerical rating, e.g., 4.5
      likesCount: null, // Number of likes, e.g., 75
      isLoading: false,
      error: null,
    };
  },
  async mounted() {
    if (this.recipeId) {
      await this.fetchRating();
    }
  },
  watch: {
    recipeId(newId, oldId) {
      if (newId && newId !== oldId) {
        this.fetchRating();
      }
    },
  },
  methods: {
    async fetchRating() {
      if (!this.recipeId) return;

      this.isLoading = true;
      this.error = null;
      // Resetting values to ensure fresh display for new recipeId
      this.ratingValue = null;
      this.likesCount = null;

      try {
        const command = `${CMD_RECIPE_RATING_GET}/${this.recipeId}`;
        const rawData = await this.sendCmd(command, null);
        const data = JSON.parse(rawData);

        if (data && typeof data.ratingValue === "number") {
          this.ratingValue = Math.max(0, Math.min(5, data.ratingValue)); // Clamp between 0 and 5
          this.likesCount =
            data.likesCount !== undefined ? data.likesCount : null;
        } else {
          // No rating or invalid data, treat as 0 stars but don't show error unless server explicitly failed
          this.ratingValue = 0; // Default to 0 if no valid ratingValue
          this.likesCount = data.likesCount !== undefined ? data.likesCount : 0;
          console.warn(
            `RecipeRating: Invalid or missing ratingValue for recipe ${this.recipeId}. Received:`,
            data
          );
        }
      } catch (err) {
        console.error(
          `RecipeRating: Error fetching rating for recipe ${this.recipeId}:`,
          err
        );
        this.error = "Не удалось загрузить рейтинг";
        this.ratingValue = 0; // Default to 0 stars on error
        this.likesCount = 0;
      } finally {
        this.isLoading = false;
      }
    },
    starClass(starIndex) {
      const rating = this.ratingValue;
      // If rating is null (still loading or error before default set), show all grey
      if (rating === null && this.isLoading)
        return "bi bi-star-fill text-secondary me-1";

      // Standard half-star logic: round to nearest 0.5 for display
      const roundedRating = Math.round((rating || 0) * 2) / 2;

      if (roundedRating >= starIndex) {
        return "bi bi-star-fill text-warning me-1"; // Full yellow star
      } else if (roundedRating >= starIndex - 0.5) {
        return "bi bi-star-half text-warning me-1"; // Half yellow star
      } else {
        return "bi bi-star-fill text-secondary me-1"; // Empty star (filled grey)
      }
    },
  },
};
</script>

<style scoped>
/* Add any specific styles if needed, me-1 on icons handles spacing */
.recipe-rating i {
  /* vertical-align: middle; */ /* Optional: if alignment issues occur */
}
</style>
